import {
  FETCH_LIST_CART_IN_LOCAL_STORAGE_SUCCESS,
  FETCH_LIST_CART_SUCCESS,
} from "redux/ActionTypes/CartActionTypes";
import { LOCAL_STORAGE_CARTS } from "shared/Constants";

const initialState = {
  listInLocalStorage: [],
  list: [],
};

const CartReducers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LIST_CART_SUCCESS: {
      const newList = { ...action.payload };
      return { ...state, list: newList };
    }
    case FETCH_LIST_CART_IN_LOCAL_STORAGE_SUCCESS: {
      const newList = [
        ...(localStorage.getItem(LOCAL_STORAGE_CARTS)
          ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_CARTS))
          : []),
      ];
      return { ...state, listInLocalStorage: newList };
    }
    default:
      return { ...state };
  }
};

export default CartReducers;
